<template>
  <div class="home">
    <GithubCorner />
    <section class="container-fluid xbox">
      <div class="row">
        <div class="col-xl-12 t-a-c mu">
          <div class="vx-box">
            <span class="x">x</span>
            <span class="v">v</span>
            <p>Vue 3.0 训练营</p>
          </div>
        </div>
      </div>
      <!-- =========== News ============ -->
      <div class="row xcard news">
        <div class="col-xl-6">
          <p class="title">Hot News</p>
          <Article
            v-for="(item, index) in news"
            :index="index"
            :key="index"
            :info="item"
          />
        </div>
        <div class="col-xl-6">
          <p class="title">Daily News</p>
          <Article
            v-for="(item, index) in dailyNews"
            :index="index"
            :key="index"
            :info="item"
          />
        </div>
      </div>
      <!-- ============ 入坑 ============ -->
      <div class="row xcard pit">
        <div class="col-xl-6">
          <p class="title">入坑指南</p>
          <Article
            v-for="(item, index) in course"
            :index="index"
            :key="index"
            :info="item"
          />
        </div>
        <div class="col-xl-6">
          <p class="title">入坑案例</p>
          <Article
            v-for="(item, index) in courseDemo"
            :index="index"
            :key="index"
            :info="item"
          />
        </div>
      </div>
      <!-- ============ 2021fd & vite ============ -->
      <div class="row xcard pit">
        <div class="col-xl-6">
          <p class="title">2021前端趋势</p>
          <Article
            v-for="(item, index) in fd2021"
            :index="index"
            :key="index"
            :info="item"
          />
        </div>
        <div class="col-xl-6">
          <p class="title">Vite系列</p>
          <Article
            v-for="(item, index) in vite"
            :index="index"
            :key="index"
            :info="item"
          />
        </div>
      </div>
      <!-- ============ 每周三问和面试题 ============ -->
      <div class="row xcard-title">
        <div class="col-xl-12 t-a-c">
          <b>问一问，面一面；更健康！</b>
        </div>
      </div>
      <div class="row xcard interview">
        <div class="col-xl-6">
          <p class="title">每周问一问</p>
          # 列出Vue2.x 到 Vue3 详细对比？ <br />
          # Vue3.0 编译做了哪些优化？（底层，源码）？<br />
          # Composition Api 与 Vue 2.x使用的Options Api 有什么区别？<br />
          # vite为什么要去革了webpack的命？
        </div>
        <div class="col-xl-6">
          <p class="title">Vue 3.0 面试</p>
          <ul>
            <li>
              <a
                href="https://blog.csdn.net/qq_35942348/article/details/110677399"
                target="_blank"
                ># 2021年，vue3.0 面试题分析（干货满满，内容详尽）</a
              >
            </li>
            <li>
              <a
                href="https://juejin.cn/post/6892295955844956167"
                target="_blank"
                ># （建议收藏）Vue3 对比 Vue2.x
                差异性、注意点、整体梳理，与React hook比又如何？（面试热点）</a
              >
            </li>
            <li>
              <a
                href="https://segmentfault.com/a/1190000038848131"
                target="_blank"
                ># Vue3.0面试题整理，希望对您有帮助(一)</a
              >
            </li>
            <li>
              <a
                href="https://blog.csdn.net/weixin_40599109/article/details/110938941"
                target="_blank"
                ># Vue3.0面试题整理，希望对您有帮助(二)</a
              >
            </li>
            <li>
              <a
                href="https://jishuin.proginn.com/p/763bfbd36f35"
                target="_blank"
                ># Vue3.0 面试题汇总【附答案噢】</a
              >
            </li>
          </ul>
        </div>
      </div>
      <!-- ============ vue2-vue3-react ============ -->
      <div class="row xcard-title">
        <div class="col-xl-12 t-a-c">
          <b>Vue2 => Vue3 &lt;= React 16/17</b>
        </div>
      </div>
      <div class="row xcard contrast">
        <div class="col-xl-6">
          <p class="title">Vue2-Vue3</p>
          <Article
            v-for="(item, index) in vue23"
            :index="index"
            :key="index"
            :info="item"
          />
        </div>
        <div class="col-xl-6">
          <p class="title">Vue3-React</p>
          <Article
            v-for="(item, index) in vue3react"
            :index="index"
            :key="index"
            :info="item"
          />
        </div>
      </div>
      <!-- ============ 招聘信息 ============ -->
      <div class="row xcard-title">
        <div class="col-xl-12 t-a-c">
          <b>招聘信息</b>
        </div>
      </div>
      <div class="row xcard contrast">
        <div class="col-xl-4">
          期待ing...
        </div>
        <div class="col-xl-4">
          获取ing...
        </div>
        <div class="col-xl-4">
          植入ing...
        </div>
      </div>
      <!-- ============ 网站信息 ============ -->
      <div class="row xcard-title">
        <div class="col-xl-12 t-a-c">
          <b>本站简介</b>
        </div>
      </div>
      <div class="row xcard contrast">
        <div class="col-xl-4">
          <p class="title">开始唠叨</p>
          <div>
            我们的GitHub地址：https://github.com/vue3/vue3-News
            <br />我们的公众号已经在路上了，敬请期待！<br />
            Thanks♪(･ω･)ﾉ<br />
          </div>
        </div>
        <div class="col-xl-4">
          <p class="title">唠叨几句</p>
          <div>
            我该如何写简介呢？<br />
            用诗歌的方式？<br />
            写段代码的方式？<br />
            ...<br />
          </div>
        </div>
        <div class="col-xl-4">
          <p class="title">继续唠叨</p>
          <div>
            谢谢大家！！！<br />
            祝各位漂亮小姐姐、小哥哥<br />
            新年好，鸿运照，烦恼的事儿往边靠，爱情滋润没烦恼，钞票一个劲儿往家跑；出门遇贵人，在家听喜报，年年有此时，岁岁有今朝，祝您一年更比一年好！<br />
          </div>
        </div>
      </div>
      <!-- ============ comments ============ -->
      <div class="row">
        <div class="comments-box">
          <div id="gitalk-container" class="comments"></div>
        </div>
      </div>
      <!-- ============ 未来可期 ============ -->
      <div class="row feature">
        <div class="col-xl-12 t-a-c">
          <p>加油ヾ(◍°∇°◍)ﾉﾞ少年，未来可期！</p>
        </div>
      </div>
      <!-- ============ 网站信息 ============ -->
      <div class="row">
        <div class="col-xl-12 copyright">
          <p>COPYRIGHT © BRUCE JENN 2021. ALL RIGHT RESERVED.</p>
          <div>
            More Information
            <a
              href="https://github.com/vue3/vue3-News"
              target="_blank"
              title="Vue3-News"
              >Vue3-News</a
            >
            - Collect from
            <a
              href="https://github.com/vue3/vue3-News"
              title="Vue3-News"
              target="_blank"
              >Vue3-News</a
            >
          </div>
        </div>
      </div>
    </section>
  </div>
</template>

<script>
import { onMounted } from "vue";

// @ is an alias to /src
import GithubCorner from "@/components/GithubCorner.vue";
import Article from "./Article";
import NewsList from "./newsList.json";
import Gitalk from "gitalk";
// import md5 from "js-md5";

const gitalk = new Gitalk({
  clientID: "a9f878495a02042b2f24",
  clientSecret: "d60ef5836933b944e3033fe93adbb3069d0d9974",
  repo: "vue3-News-comments",
  owner: "vue3",
  admin: ["Bruce Jenn"],
  language: "zh-CN",
  id: "vue3-News"
});

export default {
  name: "Home",
  components: {
    GithubCorner,
    Article,
  },
  setup() {
    onMounted(() => {
      gitalk.render("gitalk-container");
    });
    return NewsList;
  },
};
</script>

<style lang="scss" scoped>
p {
  margin: 0;
}
.hidden {
  display: none;
}
.home {
  position: relative;
  width: 100%;
}
.xbox {
  position: relative;
  padding: 50px;
  padding-top: 10px;
}

.mu {
  span {
    position: absolute;
    font-size: 150px;
    left: 38%;
    line-height: 0.6;
  }
  p {
    position: relative;
    font-weight: 900;
    font-size: 30px;
    display: inline-block;
    margin-top: 120px;
    padding: 0 20px;
    &:after {
      content: " ";
      position: absolute;
      transition: all 0.3s;
      z-index: -1;
      bottom: 0px;
      width: 100%;
      background-color: #41b88388;
      height: 18px;
      border-top-left-radius: 20px;
      border-top-right-radius: 20px;
      left: 0;
    }
  }
  .vx-box {
    position: relative;
    display: inline-block;
    width: 300px;
    height: 200px;
  }
  .vx-box:hover {
    .v {
      z-index: 1;
    }
    .x {
      z-index: 5;
    }
  }
  .v {
    color: rgb(100, 206, 170);
  }
  .x {
    color: #808080;
  }
}

.xcard-title {
  position: relative;
  margin: 40px 5px 10px;
  b {
    font-size: 24px;
    display: inline-block;
    color: #fff;
    // border: 1px solid #41b88388;
    background: #41b88388;
    padding: 5px 30px;
  }
}

.xcard {
  position: relative;
  min-height: 300px;
  border: 1px solid #ddd;
  margin-bottom: 15px;
  .title {
    font-size: 20px;
    font-weight: 900;
    position: relative;
    margin-top: 0;
    z-index: 5;
    margin-bottom: 2rem;
    &:after {
      content: " ";
      position: absolute;
      transition: all 0.3s;
      z-index: -1;
      bottom: -5px;
      width: 15px;
      background-color: #41b883;
      height: 3px;
      left: 0;
    }
  }
  & > div {
    margin: 12px 0;
    border-right: 1px solid #eee;
    &:last-child {
      border-right: none;
    }
  }
  & > div:hover .title:after {
    width: 150px;
    height: 18px;
    border-top-right-radius: 20px;
    background-color: #41b88388;
  }
}

.xcard.interview {
  min-height: 200px;
  a {
    color: #000;
    text-decoration: none;
    &:hover {
      text-decoration: underline;
    }
  }
}

.feature p {
  margin-top: 100px;
}
.copyright {
  margin-top: 50px;
  text-align: center;
}

.comments-box {
  position: relative;
  width: 100%;
  text-align: center;
  .comments {
    display: inline-block;
    text-align: left;
    width: 100%;
    max-width: 1000px;
  }
}
</style>
